import {
  PayPalProvider,
  PayPalOneTimePaymentButton,
  PayPalGuestPaymentButton,
  useEligibleMethods,
} from "@paypal/react-paypal-js/sdk-v6";

const COMPONENTS = ["paypal-payments", "paypal-guest-payments"];

function PaymentButton({ paymentMethod, ...props }) {
  const { eligiblePaymentMethods, isLoading, error } = useEligibleMethods({
    payload: {
      currencyCode: "ILS",
      paymentFlow: "ONE_TIME_PAYMENT",
    },
  });

  if (error) {
    return (
      <p role="alert" dir="rtl">
        לא ניתן לטעון את התשלום. נסו לרענן את העמוד.
      </p>
    );
  }

  if (isLoading || !eligiblePaymentMethods) {
    return <p dir="rtl">טוען תשלום מאובטח...</p>;
  }

  const funding = paymentMethod === "visa" ? "card" : "paypal";

  if (!eligiblePaymentMethods.isEligible(funding)) {
    return <p dir="rtl">אמצעי התשלום אינו זמין כרגע. בחרו אמצעי תשלום אחר.</p>;
  }

  return paymentMethod === "visa" ? (
    <PayPalGuestPaymentButton {...props} />
  ) : (
    <PayPalOneTimePaymentButton {...props} presentationMode="popup" />
  );
}

export default function PayPalCheckout({ paymentMethod = "paypal", ...props }) {
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID?.trim();

  const environment =
    process.env.REACT_APP_PAYPAL_ENVIRONMENT?.trim() || "sandbox";

  if (!clientId || !["sandbox", "production"].includes(environment)) {
    return (
      <p role="alert" dir="rtl">
        התשלום המקוון אינו זמין כרגע.
      </p>
    );
  }

  return (
    <PayPalProvider
      clientId={clientId}
      environment={environment}
      components={COMPONENTS}
      pageType="checkout"
    >
      <PaymentButton paymentMethod={paymentMethod} {...props} />
    </PayPalProvider>
  );
}
